import { useProvider } from './useProvider'

type Props = {
  provider: any
}

export const useLabel = ({ provider }: Props) => {
  const { providerClient } = useProvider({ provider })

  return providerClient?.description?.label ?? provider.name
}
